(function() {
'use strict';

angular.module('TR')
    .service('cancellerService', cancellerService);

function cancellerService($q, broker) {
    let supervisors = [];

    const service = {
        add,
        process: processFunc
    };

    function add(...validRoutes) {
        const supervisor = { validRoutes, canceller: $q.defer() };
        supervisors.push(supervisor);
        return supervisor.canceller;
    }

    function processFunc(nextRoute) {
        const remainingSupervisors = [];
        supervisors.forEach(function(s) {
            const valid = s.validRoutes.some(function(r) {
                if (r instanceof RegExp) {
                    return r.test(nextRoute);
                }
                return r === nextRoute;
            });

            if (!valid) {
                broker.publish('unblock');
                s.canceller.resolve('CANCELLED');
            } else {
                remainingSupervisors.push(s);
            }
        });

        supervisors = remainingSupervisors;
    }

    return service;
}
})();
